<template>
  <div class="service-agreement">
   <!-- <div class="top-btn" @click="handleToJobs" v-show="iosOrAndroidShow">-->
<!--      <img-->
<!--        src="https://files.wondercv.com/translate-img/new_wondercv_logo_zh-CN.png"-->
<!--        class="banner"-->
<!--        alt-->
<!--      />-->
<!--      <div>名企内推</div>-->
<!--    </div> -->
    <div class="main" :class="iosOrAndroid ? 'active' : ''">
      <div class="main-title">超级简历 WonderCV 服务协议</div>
      <div class="created-time">最新版本生效日期：2021年12月01日</div>
      <div class="welcome">欢迎您使用我们的产品！</div>
      <div class="main-item">超级简历 WonderCV（见下列定义）是由北京超职科技有限公司（下称“超职科技”或“我们”）提供的互联网软件服务。本服务协议（下称“服务条款”或者“协议”）是您与超职科技之间关于您（“您”或“用户”）访问和使用超级简历 WonderCV并使用超职科技提供的其他服务（下称“服务”）的主要协议。您注册、登录、使用超级简历 WonderCV和/或享受超职科技提供的服务，即表示您同意接受服务条款。因此，您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容。如您对协议有任何疑问，可向超级简历 WonderCV客服info@wondercv.com咨询。当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与超级简历 WonderCV达成一致，成为超级简历 WonderCV的“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。</div>
      <div class="main-item">由于互联网高速发展，您与超职科技签署的本协议列明的条款并不能完整罗列并覆盖您与超职科技之间的所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，超职科技法律声明及隐私权政策等均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用超级简历 WonderCV或超职科技的其他服务，视为您同意上述补充协议。</div>
      <div class="main-item">超职科技有权不时地对服务条款做任何修改和补充，并在超级简历 WonderCV上公布。通常情况下（例如当需要进行修改或补充以满足适用法律要求时），对服务条款的修改和补充将在公布时立即生效。您继续访问和使用超级简历 WonderCV即视为您接受修订后的服务条款。否则，您有权通过停止访问超级简历 WonderCV且拒绝使用服务、删除您在超级简历 WonderCV上的信息和帐户等方式来终止服务条款。</div>

      <div class="main-item-title">1. 定义</div>
      <div class="main-item">超级简历 WonderCV：指包括域名为https://www.wondercv.com的网站、APP客户端、微信公众号、微信小程序以及各类网络平台以及客户端。</div>
      <div class="main-item">超职科技：指北京超职科技有限公司，超级简历 WonderCV的经营者以及服务提供者。</div>
      <div class="main-item">超级简历 WonderCV服务：超职科技基于互联网，以包含超级简历 WonderCV网站、客户端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项免费或增值服务。</div>
      <div class="main-item">用户：指具有完全民事行为能力的超级简历 WonderCV服务使用者。用户身份包括“用人者”、“候选人”等。</div>
      <div class="main-item">用人者：指有用人需求，具有用人资格，在超级简历 WonderCV上发布招聘及相关信息的企事业单位或其他组织。</div>
      <div class="main-item">候选人：指利用超级简历 WonderCV服务进行职位浏览、投递等等行为的个人。</div>
      <div class="main-item">账号：指用户为使用超级简历 WonderCV服务及超职科技服务而登记注册的用户身份识别信息；用户只有注册账号才能使用超级简历 WonderCV服务及超职科技服务的服务。</div>
      <div class="main-item">超职科技的关联公司：指由超职科技控股、参股或者通过协议控制超职科技或者通过协议由超职科技控制的公司。</div>

      <div class="main-item-title">2. 用户资格</div>
      <div class="main-item">2.1 您确认，在您开始注册程序使用超级简历 WonderCV 服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力，包括（1）具备完全民事行为能力的自然人；（2）依据中华人民共和国法律、行政法规、部门规章等规范性文件成立并合法存续的企业、机关、社团、事业单位和其他组织，具有能使用超职科技服务的民事权利能力和民事行为能力并且具有合法用人资格（统称为“用人者”）。</div>
      <div class="main-item">2.2 此外，您还需确保您不是任何国家、地区或国际组织实施的贸易限制、经济制裁或其他法律法规限制的对象，也未直接或间接为前述对象提供资金、商品或服务，否则您应当停止使用超级简历 WonderCV服务，同时您理解违反前述要求可能会造成您无法正常注册及使用超级简历 WonderCV服务。</div>
      <div class="main-item">2.3 如果您是用人者，超级简历 WonderCV以及超职科技有权要求您提供相应的资质文件（包括但不限于营业执照、经营许可证等），并依据常识及社会大众通常认知水平做出是否合规的判断而不必须依据公权力机关事后通知、查处、判决等文件。对于涉及经营人力资源外包业务、劳务分包业务、猎头业务、招聘业务、职业教育培训业务等可能与超职科技业务存在竞争关系或利益冲突的企业，超职科技保留拒绝其注册、使用超职科技的权利。</div>
      <div class="main-item">2.4 为了合法、合规地为用户提供更好的服务，超职科技将不时调整用户需提交的信息。如用户不同意提供上述信息，则应当停止使用超职科技的服务。用户需同意超职科技对其注册信息资料进行审查，并就相关疑问或问题进行解答。</div>

      <div class="main-item-title">3. 账户说明</div>
      <div class="main-item">3.1 当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得超级简历 WonderCV账户并成为超级简历 WonderCV用户。</div>
      <div class="main-item">3.2 超级简历 WonderCV只允许每位用户使用一个超级简历 WonderCV账户。如有证据证明或超职科技根据超级简历 WonderCV规则判断您存在不当注册或不当使用多个超级简历 WonderCV账户的情形，超级简历 WonderCV可采取冻结或关闭账户、取消订单、拒绝提供服务等措施，如给超级简历 WonderCV及相关方造成损失的，您还应承担赔偿责任。</div>
      <div class="main-item">3.3 您有权使用您设置或确认的用户名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录超级简历 WonderCV。</div>
      <div class="main-item">3.4 由于您的超级简历 WonderCV账户关联您的个人或者授权代表的信息，您的超级简历 WonderCV账户仅限您本人以及授权代表使用。未经超级简历 WonderCV同意，您直接或间接授权第三方使用您超级简历 WonderCV账户或获取您账户项下信息的行为无效。如超职科技认定您超级简历 WonderCV账户的使用可能危及您的账户安全及/或超级简历 WonderCV信息安全的，超级简历 WonderCV可拒绝提供相应服务或终止本协议。</div>
      <div class="main-item">3.5 仅当有法律明文规定、司法裁定或经超职科技同意，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则超级简历 WonderCV有权追究您的违约责任，且由此产生的责任及后果均由您自行承担。</div>
      <div class="main-item">3.6 为使您更好地使用超级简历 WonderCV的各项服务，保障您的账户安全，超职科技可要求您按相关法律法规规定完成实名认证。</div>
      <div class="main-item">3.7 超级简历WonderCV账号不可以用于非法盈利，如因账号非法售卖、共享等原因导致账号出现任何问题，包括但不限于信息泄露、账号丢失、账号注销等，我们不予负责。</div>
      <div class="main-item">3.8如您的账户符合以下任何一条件时，则超职科技可回收您的账户，您的账户将不能再登录超级简历 WonderCV，相应服务同时终止：</div>
      <div class="main-item">
        <div>（一）未通过实名认证的超级简历 WonderCV企业账户；</div>
        <div>（二）您主动申请的；</div>
        <div>（三）您违反本协议内容的；</div>
        <div>（四）我们有理由认为您的使用行为对我们及/或他人的合法权益造成（或可能造成）侵害的。</div>
      </div>
      <div class="main-item">为保障您的账户隐私不被泄露，超级简历会记录您的登录设备号，您可以同时存在 3 个常用设备，达到 3 个上限后非常用登录设备则不允许登录。以上描述中设备包括但不限于PC浏览器、App等。您可以在 7 天内对常用登录设备进行 1 次更改处理。</div>

      <div class="main-item-title">4. 注册信息管理</div>
      <div class="main-item">4.1 真实合法</div>
      <div class="main-item">在使用超级简历 WonderCV服务时，您应当按超级简历 WonderCV页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址、资质文件如企业营业执照等），以便超职科技或其他用户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。</div>
      <div class="main-item">您设置的超职科技会员名不得违反国家法律法规及超级简历 WonderCV关于会员名的管理规定，否则超职科技可回收您的超职科技会员名。超职科技会员名的回收不影响您以邮箱、手机号码登录超级简历 WonderCV并使用超级简历 WonderCV服务。</div>
      <div class="main-item">尽管有前述规定，超职科技无义务对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、准确性、完整性、适用性及/或是否为最新资料的责任。</div>
      <div class="main-item">4.2 更新维护</div>
      <div class="main-item">您应当及时更新您提供的信息，在法律有明确规定要求超职科技作为平台服务提供者必须对部分用户（如平台卖家等）的信息进行核实的情况下，超职科技将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。</div>
      <div class="main-item">如超职科技按您最后一次提供的信息与您联系未果、您未按超职科技的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及超职科技造成的全部损失与不利后果。超职科技可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部超级简历 WonderCV服务，超职科技对此不承担责任。</div>
      <div class="main-item">4.3 账户安全规范</div>
      <div class="main-item">您的账户为您自行设置并由您保管，超职科技任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开超级简历 WonderCV。尤其用人者应对其在超级简历 WonderCV账户的实际使用人（包括但不限于用人者员工）进行严格管理，并保证实际使用人严格遵守超级简历 WonderCV的协议与规则，实际使用人在超级简历 WonderCV上进行的任何行为均视为用人者行为，用人者就上述行为承担全部责任。</div>
      <div class="main-item">账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，超职科技并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。</div>
      <div class="main-item">除超职科技存在过错外，您应对您账户项下的所有行为结果负责。</div>
      <div class="main-item">如发现任何未经授权使用您账户登录超级简历 WonderCV或其他可能导致您账户遭窃、遗失的情况，建议您立即更改密码、通知超职科技，并授权超职科技将该信息同步给其他关联平台。您理解超职科技对您的任何请求采取行动均需要合理时间，且超职科技应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除超职科技存在法定过错外，超职科技不承担责任。</div>
      <div class="main-item">若您提供任何违法、虚假、不道德或超职科技保认为不适合在超级简历 WonderCV上展示的资料；或者超职科技保有理由怀疑您的资料属于病毒程序或恶意操作；或者您违反本服务条款的规定；或者未经超职科技保同意，将超级简历 WonderCV用于商业目的，超职科技保有权暂停或终止您的帐号，并拒绝您于现在和未来使用服务之全部或任何部分。</div>

      <div class="main-item-title">5. 服务内容</div>
      <div class="main-item">超级简历 WonderCV为候选人提供4类的简历服务：</div>
      <ul class="main-item">
        <li>提供简历撰写工具。</li>
        <li>提供简历导师服务。</li>
        <li>提供人岗匹配算法。</li>
        <li>提供简历投递渠道。</li>
      </ul>
      <div class="main-item">超级简历 WonderCV为用人者提供如下服务：</div>
      <div class="main-item">根据实际需要和超职科技不时提供的其他服务内容，超职科技可能与您另行签订其他协议。同时，即使未另行签订其他协议，您使用超级简历 WonderCV的具体服务也将被视为您同意超职科技关于该具体服务的任何要求。如果其他协议和本条款之间存在冲突，应以其他协议为准，但以该冲突和与该协议特定事宜相关为限。</div>
      <div class="main-item">超职科技保留随时变更、中止或终止部分免费服务的权利，并保留根据实际情况随时调整超级简历 WonderCV提供的服务种类、形式。超职科技不承担因超级简历 WonderCV提供的任何免费服务的调整给您造成的损失。尽管有本条约定，超职科技有权在未来恰当的时机对该等免费服务内容收取相应的服务费用。超职科技保留随时终止向您提供的收费服务的权利，并保留根据实际情况随时调整超级简历 WonderCV提供的收费服务种类和形式。如果超职科技终止提供某项收费服务，超职科技的义务仅在于向您返还您尚未使用的服务期对应的部分费用。但无论如何，超职科技将尽合理的努力给您预留合理的时间以便您为该等服务变更、中止或终止做出应对。</div>

      <div class="main-item-title">6. 内容使用权</div>
      <div class="main-item">6.1 用户承诺使用超级简历 WonderCV仅用于用户自身招聘（含招聘宣传、雇主品牌建设）、找工作以及进行职业问答等用途，不得偏离网站具体功能模块之目的。</div>
      <div class="main-item">6.2 用户在超级简历 WonderCV上填写的内容（包含但不限于超级简历 WonderCV目前各产品功能里的内容）仅表明其个人的立场和观点，并不代表超职科技的立场或观点。作为内容的发表者，需自行对所发表的内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律责任及连带责任，超职科技不承担任何法律责任及连带责任。</div>
      <div class="main-item">6.3 用户在超级简历 WonderCV发布侵犯他人知识产权或其他合法权益的内容，超级简历 WonderCV有权利但无义务予以删除并保留移交司法机关处理的权利。无论是否删除或意见司法机关处理，超职科技和超级简历 WonderCV均不承担任何法律责任及连带责任。</div>
      <div class="main-item">6.4 用户不得使用超级简历 WonderCV服务发送或传播敏感信息和违反国家法律制度的信息，包括但不限于下列信息：</div>
      <ul class="main-item">
        <li>反对宪法所确定的基本原则的；</li>
        <li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
        <li>损害国家荣誉和利益的；</li>
        <li>煽动民族仇恨、民族歧视，破坏民族团结的；</li>
        <li>破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
        <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
        <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
        <li>侮辱或者诽谤他人，侵害他人合法权益的；</li>
        <li>侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</li>
        <li>存在可能破坏、篡改、删除、影响超级简历 WonderCV或超职科技任何系统正常运行或未经授权秘密获取超职科技平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</li>
        <li>含有法律、行政法规禁止的其他内容的。</li>
      </ul>
      <div class="main-item">用户发布任何上述内容的，超级简历 WonderCV和超职科技将作出独立判断立即暂停或终止用户的服务帐号并且删除相关内容。用户需对自己在网上的行为承担法律责任，届时超级简历 WonderCV和超职科技不承担任何法律责任及连带责任。对于用户已支付的服务费用（如有），超级简历 WonderCV和超职科技有权不予退还。</div>
      <div class="main-item">6.5 用人者的特别保证</div>
      <div class="main-item">对于用人者及其关联单位（包括但不限于分公司、子公司、独立事业部等）使用超级简历 WonderCV开展招聘相关服务事宜，用人者承诺并担保如下：用人者使用超级简历 WonderCV服务仅限用于自身员工招聘，承诺不利用服务从事其他事宜，包括但不限于为其他第三方代为招聘，收集求职者数据、简历用作他用，以自身招聘为名招收学员或办理贷款，使用平台服务从事公司业务经营活动，利用平台服务中聊天沟通等功能进行广告营销等情形。用人者成功入驻后，不得出现本协议条款中所列举的禁止情形。用人者使用超级简历 WonderCV和超职科技服务，保证严格遵守平台用户协议、平台规则及与超级简历 WonderCV签署的一切合同文件（如有）。在使用服务期间，保证不从事任何违反平台规则的业务、不发布任何违反平台规则的信息。</div>
      <div class="main-item">如用人者违反上述承诺，超级简历 WonderCV有权立即停止提供服务并对用人者在平台上的公司主页和/或发布的信息进行封禁，且对于用人者已支付的服务费用（如有），超级简历 WonderCV有权不予退还。</div>
      <div class="main-item">6.6 找工作行为</div>
      <div class="main-item">用户（候选人）可通过超级简历 WonderCV简历模块完善个人简历及相关信息，也可上传独立简历。</div>
      <div class="main-item">用户利用超级简历 WonderCV提供的沟通工具（如有）与用人者进行沟通的，应严格遵守本协议的全部规则，且沟通行为及沟通内容应仅限于找工作相关。</div>
      <div class="main-item">
        用户找工作，应当如实提供本人基本信息以及应聘岗位相关的知识、技能、工作经历等情况，保证遵守法律、法规对于服务期、从业限制、保密等方面的规定。如前述信息不实或行为违反法律法规的，用户自行承担相应的不利后果，包括被用人者不予录用或录用后解除劳动关系等。因此给用人者、超级简历 WonderCV或第三人造成损失的，还应承担相应的赔偿责任。
        超级简历 WonderCV将不时举办某些专项活动，用于满足用人者特殊的招聘需求和候选人的职业发展需求。用户可能需要满足一定的要求，如工作经验、技能证书等，经过超级简历 WonderCV一定审查，方可获得参与资格。
      </div>
      <div class="main-item">用户理解并同意，为向用户提供更全面、更便利的招聘服务，增加求职效率和面试沟通机会，超级简历 WonderCV及其关联公司可能通过短信、电子邮件、微信公众号、APP PUSH、电话等多种方式向用户推送有关招聘活动的专场活动信息、职位信息等信息（包括商业信息或非商业信息）。此外，为了便于让用户高效、省时、灵活、智能地投递简历，用户可以选择开启智能投递功能，此时我们将于每日内自动为用户投递职位优选列表中的高匹配职位。请您注意并知悉，用户在选择开启智能投递功能后，超级简历 WonderCV通过算法与用户在我们平台使用产品或服务所留存的数据进行计算后自动为用户推荐的适合用户的职位信息，但用户仍然可以在超级简历 WonderCV主页面上主动搜索用户认为感兴趣的职位。智能投递功能到期后将自动关闭。如用户希望继续使用该功能的，用户需要再次点击钮选择开启。在默认投递周期尚未结束前，用户也可以选择前往【设置】中自行提前关闭。</div>
      <div class="main-item">此外，为了使用户在求职过程中能实时了解求职进展，我们可能向用户推送消息。如果您不想接受我们以任何方式向您推送的信息，您可以选择收回您的授权同意。您可以通过我们在电子邮件中的退订按钮或按照我们在短信中提供的退订说明进行退订。需要说明的是，当涉及到系统管理或安全信息等事关您使用服务或信息安全的重要事项时，我们仍会向您推送该信息，以确保您能够顺畅使用超级简历 WonderCV相关服务。</div>
      <div class="main-item">您理解并同意，对上述的相关信息推送，您应审慎判断其真实性和可靠性，除法律法规明确规定外，您应对因该信息而实施的行为负责。</div>

      <div class="main-item">6.7 招聘行为</div>
      <div class="main-item">用户（用人者）通过本平台审核，并依据法律法规及本协议规定提供招聘简章、营业执照或有关部门批准设立的文件、经办人身份证件、用人单位的委托证明等资料后，方可发布招聘信息、进行招聘活动。</div>
      <div class="main-item">用人者发布的信息除用于招聘所需的必要信息外不得有其他内容，包括但不限于自身产品或服务的推广、销售等。</div>
      <div class="main-item">超级简历 WonderCV认为有必要的情况下，有权对用户发布的信息做出审查、指导，并有权要求用户做出解释、更正或说明。</div>
      <div class="main-item">用户应当确保发布的招聘信息真实合法。用户招聘信息不实或违规的，用户自行承担相应的不利后果。因此给候选人、超级简历 WonderCV或第三人造成损失的，还应承担相应的赔偿责任。涉及违法或构成刑事犯罪的，依据法律法规承担相应的责任。</div>
      <div class="main-item">用户发布招聘信息或利用超级简历 WonderCV提供的沟通工具与候选人进行沟通的，应严格遵守本协议的全部规则，另外还不得涉及以下内容；非互联网行业职位；涉及性别、地域等各类歧视；涉及薪酬面议、联系方式内容；涉及夸张性描述、夸大性承诺或虚假宣传；职位内容重复描述、无意义描述；职位要求与职位描述不一致；侮辱、诽谤、骚扰、诋毁、攻击第三人的；代招聘服务；招聘信息虚假；与招聘无关；违反社会公序良俗的其他情形。如用户违反上述要求，超级简历 WonderCV有权立即采取下列一个或多个措施；立即停止提供服务；对相关信息予以下线、删除或要求整改；封禁用户账号等。</div>
      <div class="main-item">6.8 用户之间的保密义务</div>
      <div class="main-item">用户对利用超级简历 WonderCV服务从而获取的其他用户的任何信息，负有保密的义务。保密的程度依据法律法规、用户间的合意以及一般人的合理注意义务决定。</div>
      <div class="main-item">6.9 用户间纠纷</div>
      <div class="main-item">候选人与用人者之间的线下活动，包括沟通、面试、入职、建立劳动关系等，不受超级简历 WonderCV的约束。双方发生纠纷的，依据法律法规、双方合同处理，超级简历 WonderCV不负责处理。</div>
      <div class="main-item">超级简历 WonderCV提供用户反馈渠道，包括网站特定模块或功能，用户可按特定方式表达、反映用户间的纠纷，超级简历 WonderCV将尽快处理这些问题，但所做出的答复可能不具有法律约束力，用户仍然可以按照法律法规规定将纠纷提交相关公权力机关。</div>

      <div class="main-item-title">7. 用户信息的保护及授权</div>
      <div class="main-item">7.1 个人信息的保护</div>
      <div class="main-item">超职科技非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用超职科技提供的服务时，您同意超职科技按照在超职科技上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。因此超职科技建议您完整地阅读用户隐私条款，以帮助您更好地保护您的隐私权。</div>
      <div class="main-item">
        使用超级简历 WonderCV和超职科技提供的服务，即表示您同意超职科技合法收集和使用有关您及您所使用服务的技术性或诊断性信息。收集到的这些信息将用于改进超级简历 WonderCV产品的内容和技术，提升超级简历 WonderCV的服务品质。
        超职科技不会将您的信息和内容提供或出售给其他的组织或个人，但以下情况除外：
      </div>
      <ul class="main-item">
        <li>您的事先同意或授权，或您于超级简历 WonderCV上主动与第三方进行分享操作；</li>
        <li>司法机关或有权政府机构或任何法律法规部门规章要求超职科技提供该等信息；</li>
        <li>您违反了本服务条款，且超职科技需要向第三方提供的。</li>
      </ul>
      <div class="main-item">7.2 非个人信息的保护和授权</div>
      <div class="main-item">
        对于您提供、发布及在使用超级简历 WonderCV或超职科技服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，均不会因上传、发布等行为发生知识产权、肖像权等权利的转移。除非我们另行说明，在法律允许的范围内，您免费授予超职科技非排他的、无地域限制的许可使用（包括存储、使用、复制、修订、编辑、发布、展示、翻译、分发上述信息或制作派生作品，以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内等）及可再许可第三方使用的权利，以及可以自身名义对第三方侵权行为取证及提起诉讼的权利。
        为方便您使用超级简历 WonderCV和超职科技的其他相关服务，您授权超职科技将您在账户注册和使用超级简历 WonderCV和超职科技服务过程中提供、形成的信息传递给超职科技的关联服务提供者，或从关联服务提供者获取您在使用相关服务期间形成的信息。
      </div>

      <div class="main-item-title">8. 版权</div>
      <div class="main-item">8.1 本协议条款明确规定的，以及任何与超级简历 WonderCV或者超职科技服务有关的内容的知识产权，由超职科技所享有。该条款所指内容包括但不限于超级简历 WonderCV的外观设计、计算机代码、内容、资讯、用户信息等。该条款所指知识产权包括但不限 于专利权、著作权、商标权等。未经超职科技事先书面许可，您不能复制、拷贝、或者使用任何部分的代码和外观设计。</div>
      <div class="main-item">8.2 超职科技将通过技术手段对用户数据进行去标识化处理（去标识化处理的信息将无法识别主体），在此情况下超职科技有权使用已经去标识化的信息。在个人信息进行脱敏处理的前提下，对用户数据进行分析并予以利用所形成的所有智力成果均归属于超职科技所有（包括但不限于专利权、著作权；例如基于平台用户去标识化信息对互联网行业及招聘领域的分析报告等）。</div>

      <div class="main-item-title">9. 数据安全</div>
      <div class="main-item">超职科技将尽合理的努力保护您的信息安全，并为此采取合理的数据传输、存储、转换等预防保护措施。但是，互联网数据传输、存储、转换均可能存在一定未知且不确定的数据安全风险，该等风险将导致包括但不限于数据丢失、泄露、损坏、无法读取或提取等后果。您确认，您已明确知晓并同意接受该等因互联网引发的风险和后果，并已采取恰当的措施（例如数据备份等），以便在该等风险发生时将损失降至最低。</div>
      <div class="main-item">如果您发现了任何有关超级简历 WonderCV的潜在安全风险（如系统漏洞等）或者个人信息安全事件，您可以向超级简历 WonderCV及时反馈并联系我们。</div>
      <div class="main-item">因互联网技术本身等非超职科技主观故意或重大过失导致危害您数据安全的，超职科技不承担任何赔偿责任。因超职科技重大过失危害您数据安全的，超职科技的赔偿责任以向您收取的服务费用为上限。</div>

      <div class="main-item-title">10. 免责声明</div>
      <div class="main-item">一旦您注册成为用户即表示您与超职科技达成协议，完全接受本服务条款项下的全部条款。对免责声明的解释、修改及更新权均属于超职科技所有。</div>
      <ul class="main-item">
        <li>由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄漏，或其他非因超职科技原因导致的个人信息的泄漏，超职科技不承担任何法律责任；</li>
        <li>任何第三方根据超职科技各服务条款及声明中所列明的情况使用您的个人信息，由此所产生的纠纷，超职科技不承担任何法律责任以及连带责任；</li>
        <li>任何由于黑客攻击、电脑病毒侵入或政府管制而造成的暂时性网站关闭，超职科技不承担任何法律责任；</li>
        <li>我们鼓励用户充分利用超级简历 WonderCV自由地发布和共享自己的信息。您可以自由发布文字、图片等内容，但这些内容必须位于公共领域内，或者您拥有这些内容的使用权。同时，用户不应在自己的个人主页或超级简历 WonderCV的任何其他地方发布受版权保护的内容；</li>
        <li>用户在超级简历 WonderCV发布侵犯他人知识产权或其他合法权益的内容，超职科技有权予以删除，并保留移交司法机关处理的权利；</li>
        <li>用户对于自己创作并在超级简历 WonderCV上发布的合法内容依法享有著作权及其他相关权利；</li>
        <li>互联网是一个开放平台，用户将图片等资料上传到互联网上，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，用户必须充分意识到此类风险的存在。用户明确同意使用超职科技服务所存在的风险将完全由用户自己承担；因用户使用超职科技服务而产生的一切后果也由用户自己承担，超职科技对用户不承担任何责任。</li>
        <li>超级简历 WonderCV对用户的真实资信状况、用户发布信息的真实性、合法性、准确性等不作保证。超级简历 WonderCV不对简历的内容做实质性审查，不保证简历的真实、完整、准确;超级简历 WonderCV不对用户实际经营状况做实质性审查，不对用户的资信状况做出保证。因上述原因给第三方造成的损失，超级简历 WonderCV不承担责任。</li>
        <li>用户通过超级简历 WonderCV获取的任何资料和信息，无论其来自于超级简历 WonderCV或任何外部链接，超级简历 WonderCV对其不做出任何保证。超级简历 WonderCV提供与其它互联网上的网站或资源的链接，用户可能会因此跳转至其它运营商经营的网站，但不表示超级简历 WonderCV与这些运营商有任何关联关系。其它运营商经营的网站均由各经营者自行负责，不属于超级简历 WonderCV控制及负责范围之内。对于存在或来源于此类网站或资源的任何内容、广告、物品或其它资料，超级简历 WonderCV亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、物品或服务所产生的任何损害或损失，超级简历 WonderCV不负任何直接或间接的责任。涉及上述条款中的情形，而造成的用户利润、商誉等损失，超级简历 WonderCV不承担任何直接、间接、附带、惩罚性的赔偿。</li>
        <li>超级简历 WonderCV将不时地指定超职科技的关联公司或者第三方作为超级简历 WonderCV的代理、基础服务商、技术支持方等，以便为用户提供本平台相应的服务。如用户需使用第三方服务以便使用超级简历 WonderCV相应功能（例如使用第三方账号登录超级简历 WonderCV、使用第三方支付工具购买超级简历 WonderCV付费服务等），还应相应遵守第三方服务提供商的相应规则。</li>
      </ul>

      <div class="main-item-title">11. 服务变更/中断/终止</div>
      <div class="main-item">11.1 如因系统维护或升级的需要而暂停网络服务、调整服务功能的，超职科技将尽可能事先在网站上（https://www.wondercv.com）、APP客户端或者微信公众号进行通告。网站服务中断期间，超级简历WonderCV无需为此而承担对用户造成的任何经济赔偿。因不可抗力事件、情况紧急或政策等原因导致超级简历 WonderCV以及超职科技未能实现提供通告的，暂行中止履行本合同项下的义务，超级简历 WonderCV以及超职科技无需为此而承担违约责任在内的法律责任。</div>
      <div class="main-item">11.2 如发生下列任何一种情形，超职科技有权单方面中断或终止向用户提供服务而无需通知用户：</div>
      <ul class="main-item">
        <li>用户提供的个人资料不真实；</li>
        <li>您存在盗用他人账户、发布违禁信息、骗取他人财物或采取不正当手段谋利等行为；</li>
        <li>用户使用本服务的行为若有任何违反国家法律法规或侵犯任何第三方合法权益的情形；</li>
        <li>用户违反本服务条款中约定的使用规则；</li>
        <li>未经超职科技同意，将超级简历 WonderCV用于商业目的。</li>
      </ul>
      <div class="main-item">11.3 本协议终止后，除法律有明确规定外，超职科技无义务向您或您指定的第三方披露您账户中的任何信息。</div>
      <div class="main-item">11.4 本协议终止后，超职科技仍享有下列权利：</div>
      <div class="main-item">（一）继续保存您留存于超级简历 WonderCV上的各类信息；</div>
      <div class="main-item">（二）对于您过往的违约行为，超职科技仍可依据本协议向您追究违约责任。</div>

      <div class="main-item-title">12. 服务条款的完善和修改</div>
      <div class="main-item">超职科技有权根据互联网的发展和中华人民共和国有关法律、法规的变化，不时地完善和修改超职科技服务条款。超职科技保留随时修改服务条款的权利，用户在使用超职科技的服务时，有必要对最新的超职科技服务条款进行仔细阅读和重新确认，当发生相关争议时，以最新的服务条款为准。</div>

      <div class="main-item-title">13. 特别约定</div>
      <div class="main-item">
        本服务条款及其下的服务受中华人民共和国法律管辖，并按之解释。
        若用户利用本服务从事任何违法或侵权行为，由用户自行承担全部责任，超职科技不承担任何法律责任及连带责任。因此给超职科技或任何第三方造成任何损失的，用户应负责全额赔偿。
      </div>
      <div class="main-item">您因使用超级简历 WonderCV或超职科技符合所产生的有关争议，由超职科技与您协商解决。协商不成时，任何一方均可向超职科技住所地的人民法院提起诉讼。</div>

      <div class="main-item-title">14. 可分性</div>
      <div class="main-item">本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</div>

      <div class="main-item-title">15. 联系我们</div>
      <div class="main-item">欢迎您对我们的服务条款提出意见。如有任何问题、意见或疑虑，请发邮件至info@wondercv.com 此电子邮件地址作为本服务条款的组成部分可能会不时进行更新。</div>
      <div class="main-item">©北京超职科技有限公司保留一切权利。</div>
    </div>
  </div>
</template>
<script>
import { envMixin } from '../../assets/js/mixin/global'
export default {
  mixins: [ envMixin ],
  data() {
    return {
      //  isAndroid: navigator.userAgent.includes('android_wondercv_app')
    };
  },
  mounted() {
    if(window.ReactNativeWebView){
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'pageMounted',
        data: `pageMounted`,
      }))
    }
  },
  methods: {
    handleToJobs() {
      window.location.href = "https://m.wondercv.com/jobs/";
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/global/variable";
@import "@/assets/scss/global/mixin";
.service-agreement {
  overflow: hidden;
  background: #f5f5f7;
  color: #333;
  width: 100%;
  .top-btn {
    display: flex;
    justify-content: space-between;
    height: 44px;
    align-items: center;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    padding: 0 15px;
    z-index: 1;
    background: #fff;
    .banner {
      width: 100px;
      height: 30px;
      display: block;
    }
  }
  .main {
    padding: 0 15px;
    margin-top: 32px;
    .main-title {
      font-size: 20px;
      text-align: center;
    }
    .created-time {
      font-size: 14px;
      line-height: 1.5;
      margin-top: 10px;
      padding-bottom: 16px;
      border-bottom: 1px solid #eee;
      font-weight: bold;
    }
    .welcome {
      margin: 20px 0;
      margin-bottom: 30px;
      font-size: 16px;
    }
    .main-item {
      line-height: 1.5;
      margin-bottom: 20px;
    }
    ul {
      li {
        list-style-position: inside;
      }
    }
    .main-item-title {
      font-size: 18px;
      margin-bottom: 20px;
    }
  }
  .main.active{
    margin-top: 30px;
  }
}
</style>
